import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const EASE = [0.76, 0, 0.24, 1];

export const Vision = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-60, 120]);

  return (
    <section
      id="vision"
      ref={ref}
      className="relative border-t hairline py-24 md:py-48 overflow-hidden"
      data-testid="vision-section"
    >
      <div className="grid grid-cols-12 px-6 md:px-10 lg:px-14 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-3 label">06 — North Star</div>

        <div className="col-span-12 md:col-span-9 relative">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: EASE }}
            className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.05] max-w-5xl text-ink"
          >
            To build the most{" "}
            <span className="italic">culturally fluent</span> digital studio for
            modern luxury —{" "}
            <span className="italic">where every brand we touch feels</span>{" "}
            considered, magnetic, and unmistakably itself.
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 mt-16 md:mt-24">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
            >
              <span className="label">Vision</span>
              <p className="mt-5 font-sans text-base md:text-lg text-ink/80 leading-relaxed">
                A world where great marketing feels less like advertising and
                more like editorial — beautifully art-directed, quietly
                intelligent, and built on a foundation of real consumer
                understanding.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
            >
              <span className="label">Mission</span>
              <p className="mt-5 font-sans text-base md:text-lg text-ink/80 leading-relaxed">
                To partner with founders and beauty houses to craft campaigns
                that convert without compromising taste — pairing sharp
                strategy, precise storytelling, and disciplined execution across
                social, PR, shoots, ads, and digital experience.
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Giant italic number */}
      <motion.span
        style={{ y }}
        className="pointer-events-none absolute right-0 bottom-10 font-serif italic text-[28vw] leading-none text-ink/[0.05] select-none"
        aria-hidden="true"
      >
        05
      </motion.span>
    </section>
  );
};

export default Vision;
